import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BACKEND_URL } from '../config';
import { toast } from 'sonner';
import axios from 'axios';
import Layout from '../components/Layout';
import { Badge } from 'lucide-react'; // Placeholder

const Admin = () => {
  const [password, setPassword] = useState("");
  const [authorized, setAuthorized] = useState(false);
  const [registrations, setRegistrations] = useState([]);

  const fetchRegs = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/admin/registrations?password=${password}`);
      setRegistrations(res.data);
      setAuthorized(true);
    } catch (e) {
      alert("Invalid Password");
    }
  };

  const handleVerify = async (regId) => {
    if(!window.confirm("Are you sure you want to verify this payment manually?")) return;
    try {
        await axios.put(`${BACKEND_URL}/api/admin/verify/${regId}?password=${password}`);
        toast.success("Verified successfully!");
        fetchRegs();
    } catch(e) {
        toast.error("Verification failed");
        console.error(e);
    }
  };

  const getStatusColor = (status) => {
    switch(status) {
        case 'VERIFIED': return 'bg-green-100 text-green-800';
        case 'NEEDS_REVIEW': return 'bg-orange-100 text-orange-800';
        case 'NOT_SUBMITTED': return 'bg-gray-100 text-gray-800';
        default: return 'bg-gray-100';
    }
  };

  return (
    <Layout>
      <div className="container mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-8 text-primary">Admin Dashboard</h1>

        {!authorized ? (
          <div className="max-w-md mx-auto">
                <div className="mb-6 text-center">
                    <Link to="/admin/settings" className="text-primary hover:underline font-semibold">
                        Go to Event Settings &rarr;
                    </Link>
                </div>
              <div className="bg-white p-6 rounded shadow border">
                <label className="block mb-2 font-bold">Admin Password</label>
                <div className="flex gap-2">
                  <input 
                    type="password" 
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    className="flex-1 border p-2 rounded"
                  />
                  <button onClick={fetchRegs} className="bg-primary text-white px-4 py-2 rounded">Login</button>
                </div>
              </div>
          </div>
        ) : (
          <div className="bg-white rounded shadow overflow-x-auto">
             <div className="p-4 flex justify-between items-center border-b">
                <h2 className="font-bold">Total Registrations: {registrations.length}</h2>
                <button onClick={fetchRegs} className="text-sm text-primary hover:underline">Refresh</button>
             </div>
             <table className="w-full text-left text-sm">
                <thead className="bg-secondary/10 text-secondary-foreground font-serif text-base">
                    <tr>
                        <th className="p-4">Name</th>
                        <th className="p-4">Email / Phone</th>
                        <th className="p-4">Status</th>
                        <th className="p-4">Payment Details</th>
                        <th className="p-4">Date</th>
                    </tr>
                </thead>
                <tbody className="divide-y">
                    {registrations.map(reg => (
                        <tr key={reg.registration_id} className="hover:bg-gray-50">
                            <td className="p-4 font-medium">{reg.full_name}</td>
                            <td className="p-4">
                                <div>{reg.email}</div>
                                <div className="text-xs text-muted-foreground">{reg.phone}</div>
                            </td>
                            <td className="p-4">
                                <div className="flex items-center gap-2">
                                    <span className={`px-2 py-1 rounded-full text-xs font-bold ${getStatusColor(reg.payment_status)}`}>
                                        {reg.payment_status}
                                    </span>
                                    {reg.payment_status === 'NEEDS_REVIEW' && (
                                        <button 
                                            onClick={() => handleVerify(reg.registration_id)}
                                            className="text-xs bg-green-600 text-white px-2 py-1 rounded hover:bg-green-700 shadow-sm transition-colors"
                                        >
                                            Approve
                                        </button>
                                    )}
                                </div>
                            </td>
                            <td className="p-4">
                                {reg.payment_details ? (
                                    <div className="space-y-1">
                                        <div className="font-mono text-xs">Amt: {reg.payment_details.amount_detected || 'N/A'}</div>
                                        <div className="font-mono text-xs">UTR: {reg.payment_details.utr_detected || 'N/A'}</div>
                                        {reg.payment_details.screenshot_url && (
                                            <a href={reg.payment_details.screenshot_url} target="_blank" rel="noreferrer" className="text-primary text-xs underline">View Screenshot</a>
                                        )}
                                    </div>
                                ) : <span className="text-gray-400">-</span>}
                            </td>
                            <td className="p-4 text-xs text-muted-foreground">
                                {new Date(reg.created_at).toLocaleDateString()}
                            </td>
                        </tr>
                    ))}
                </tbody>
             </table>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Admin;
